<template>
  <div>
    <div class="validation_errors_cont"></div>
    <ul class="filters-bar" style="border-bottom: 1px solid #b1b6d1;">
      <li v-if="mode == 'custom'" class="" style="border:0;">
        <!-- when filter -->
        <!-- {{ T__("Search by Invitee email, Invitee name or Booking ID") }} -->
        <input
          id="booking_search_text"
          type="search"
          name="booking_search_text"
          placeholder="Search"
          v-model="filter_options.search_text"
        />
        <span>Search by invitee name, email or booking ID</span>
      </li>
      <li v-if="mode == 'custom'" class="bf-when">
        <!-- when filter -->
        <span class="bf-label" style="margin-right: -44px;">When?</span>
        <TypeToSelect
          v-model="filter_options.when"
          :options="when_options"
          label_field="label"
          value_field="value"
          class="no-border"
        />
        <v-date-picker
          v-if="filter_options.when == 'date_range'"
          mode="range"
          :columns="2"
          @dayclick="log"
          v-model="filter_options.date_range"
          :masks="{ input: ['YYYY-MM-DD'] }"
          id="bf-dr-selector"
        >
          <input
            type="text"
            readonly
            :value="
              $options.filters.wpcal_format_date_style1(
                filter_options.date_range.start
              ) +
                ' - ' +
                $options.filters.wpcal_format_date_style1(
                  filter_options.date_range.end
                )
            "
          />
        </v-date-picker>
      </li>
      <li class="bf-host">
        <!-- host filter -->
        <span class="bf-label" style="margin-right: -35px;">Host</span>
        <TypeToSelect
          v-model="filter_options.admin_user_id"
          :options="$store.getters.get_managed_active_admins_for_host_filter"
          label_field="name"
          value_field="admin_user_id"
          class="no-border"
        />
      </li>
      <li class="bf-status">
        <!-- status filter -->
        <span class="bf-label" style="margin-right: -46px;">Status</span>
        <TypeToSelect
          v-model="filter_options.booking_status"
          :options="booking_status_options"
          label_field="label"
          value_field="value"
          class="no-border"
        />
      </li>
      <li class="bf-et">
        <!-- service filter -->
        <span class="bf-label" style="margin-right: -70px;">Event Type</span>
        <TypeToSelect
          v-model="filter_options.service_id"
          :options="service_filter_options"
          label_field="name"
          value_field="id"
          class="no-border"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import TypeToSelect from "@/components/form_elements/TypeToSelect.vue";

import axios from "axios";

export default {
  name: "ServiceBookingFilters",
  components: {
    TypeToSelect
  },
  model: {
    prop: "filter_options",
    event: "changed-filter-options"
  },
  props: {
    filter_options: {
      type: Object
    },
    mode: {
      type: String,
      default: "normal"
    }
  },
  data() {
    return {
      when_options: [
        { label: "All", value: "0" },
        { label: "Upcoming", value: "upcoming" },
        { label: "Past", value: "past" },
        { label: "Date range", value: "date_range" }
      ],
      booking_status_options: [
        { label: "All", value: "0" },
        { label: "Active", value: "1" },
        { label: "Cancelled", value: "-1" },
        { label: "Rescheduled", value: "-5" }
      ],
      service_list: []
    };
  },
  computed: {
    service_filter_options() {
      let services = this.clone_deep(this.service_list);
      if (Array.isArray(services)) {
        let all_service_as_service = {
          id: "0",
          name: "All"
        };
        services.unshift(all_service_as_service);
      }
      return services;
    }
  },
  methods: {
    async load_service_list() {
      let cached_data = await this.$store.dispatch(
        "get_dynamic_cache_by_prop",
        "managed_services_for_current_admin"
      );
      if (cached_data) {
        this.service_list = cached_data;
        return;
      }
      let action = "get_managed_services_for_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = {
        filter_by_admin_id: "0"
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            dont_notify_success: true
          });
          if (
            response.data &&
            response.data[action].hasOwnProperty("service_list")
          ) {
            this.service_list = response.data[action].service_list;
            this.$store.commit("set_dynamic_cache_by_prop", {
              prop: "managed_services_for_current_admin",
              value: this.service_list,
              expiry_secs: 5 * 60 /* 5 mins */
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    //this.$store.dispatch("load_managed_active_admins_details"); //to avoid multiple calling on each tab click or load this code is used in ServiceBookings.vue
    this.load_service_list();
  }
};
</script>
<style>
ul.filters-bar {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 5px;
  padding-bottom: 0;
}
ul.filters-bar li {
  display: flex;
  border-radius: 5px;
  margin-bottom: 5px;
  border: 1px solid #b1b6d1;
  background-color: #eff3fb;
  position: relative;
}
ul.filters-bar li:hover {
  background-color: #dfe4ec;
}
/*ul.filters-bar li[class^="bf-"] {
  overflow: hidden;
}*/
ul.filters-bar li:not(:last-child) {
  margin-right: 5px;
}
ul.filters-bar li .bf-label {
  color: #7c7d9c;
  font-size: 11px;
  text-transform: uppercase;
  align-self: center;
  z-index: 1;
  padding-left: 7px;
  pointer-events: none;
}
#booking_search_text {
  border: 1px solid #b1b6d1;
}
#booking_search_text + span {
  position: absolute;
  background-color: rgb(19 19 54 / 70%);
  color: #fff;
  font-size: 11px;
  white-space: nowrap;
  padding: 5px 7px;
  bottom: -26px;
  border-radius: 3px;
  z-index: 2;
  display: none;
}
#booking_search_text:focus + span {
  display: block;
}
#bf-dr-selector input[readonly] {
  background-color: #eff3fb;
  border: 0;
  padding: 0px 10px 0 10px;
  border-left: 1px solid #b1b6d1;
  border-radius: 0 5px 5px 0;
  font-size: 13px;
  margin-left: 0px;
  width: 186px;
  cursor: default;
}
</style>
